import { useTranslation } from "react-i18next";

import { useFlow } from "@/contexts/FlowContext.tsx";
import { FlowPageInterface } from "@/interfaces";
import ContactsCard from "@/app/occupants/components/contacts-card";
import AlertsScheduleNotice from "@/components/alerts-schedule-notice";

export const FlowPageAlerts = (props: FlowPageInterface) => {
  const { t } = useTranslation();
  const { contractId } = useFlow();

  if (!props.currentlyVisible) {
    return <></>;
  }

  return (
    <div className={"max-w-6xl mx-auto"}>
      {/* The alert hours sit beside the description on a wide screen, under it otherwise. */}
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between lg:gap-10">
        <div className="min-w-0 lg:max-w-[700px]">
          <div className={"follo-label text-card-foreground"}>
            {t("fe.pages.flow.steps.alerts.title")}
          </div>
          <div className="text-sm font-normal text-muted-foreground leading-5 my-3">
            <div className={"mb-2 md:max-w-[700px]"}>
              {t("fe.pages.flow.steps.alerts.description1")}
            </div>
            <div className="md:max-w-[700px] mb-2">
              {t("fe.pages.flow.steps.alerts.description2")}
            </div>
          </div>
        </div>
        <AlertsScheduleNotice />
      </div>
      {contractId && <ContactsCard contractId={contractId} onConfirm={() => props.nextStep()} />}
    </div>
  );
};
